var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"home\">\n<div class=\"flex-container\">\n<div class=\"flex-item\">\n<div class=\"title-description\">\nConnect to Elasticsearch...\n</div>\n<form class=\"form-inline\" ng-submit=\"homeCtrl.connect()\" name=\"homeCtrl.form\">\n<div class=\"input-group\">\n<span class=\"input-group-addon\"><i class=\"fa fa-sitemap\" aria-hidden=\"true\"></i></span>\n<input type=\"text\" class=\"form-control\" ng-model=\"homeCtrl.connection\" placeholder=\"example > http://127.0.0.1:9200\">\n<span class=\"input-group-btn\">\n<button type=\"submit\" class=\"btn btn-primary\">Connect</button>\n</span>\n</div>\n</form>\n<div class=\"form-group cluster-picker\">\n<eshq-clusters-button></eshq-clusters-button>\n</div>\n</div>\n</div>\n</div>\n";
var id1="containers/home/home.view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/containers/home/home.view.html
// module id = 813
// module chunks = 0